if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('[js-carousel]');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.carousel.innerHTML = recommendations.innerHTML;
            this.carousel.classList.remove('hidden');
          }
        })
        .catch((e) => {
          console.error(e);
        });

      observer.unobserve(this.closest('section'));
    }

    connectedCallback() {
      this.carousel = this.querySelector('[js-carousel]');

      this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        {
          rootMargin: '0px 0px 200px 0px',
        },
      ).observe(this.closest('section'));
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
